import UiDetail from "./UiDetail";
import { EnumMiezzFormItemType, MiezzFormItem } from "@/models/MiezzForm";
import { EnumPipe } from "@/models/EnumPipe";
import UiGroup from "./UiGroup";

/**
 * 船公司详细
 * @description 自动生成的代码,请勿修改
 */
export default class DtoDetailParamShippingCompany extends UiDetail<string> {
    constructor() {
        //无参构造函数
        super()
    }

    [proName: string]: any;
    /**
     * 中文名称
     */
    NameZh?: string;
    /**
     * 英文名称
     */
    NameEn?: string;
    /**
     * 英文缩写
     */
    AbbrEn?: string;
    /**
     * 查询网址
     */
    Url?: string;
}

/**
 * 船公司详细-表单校验
 */
export const DtoDetailParamShippingCompanyRules = {
}

/**
 * 船公司详细-设置项
 */
export const DtoDetailParamShippingCompanyMiezzDetailItems: MiezzFormItem[] = [
  {
    Prop: "NameZh",
    Label: "中文名称",
    Type: EnumMiezzFormItemType.Text,
  },
  {
    Prop: "NameEn",
    Label: "英文名称",
    Type: EnumMiezzFormItemType.Text,
  },
  {
    Prop: "AbbrEn",
    Label: "英文缩写",
    Type: EnumMiezzFormItemType.Text,
  },
  {
    Prop: "Url",
    Label: "查询网址",
    Type: EnumMiezzFormItemType.Text,
  },
]
